import { render, staticRenderFns } from "./inviteFriendsGridItem.vue?vue&type=template&id=058bc432&scoped=true"
import script from "./inviteFriendsGridItem.vue?vue&type=script&lang=js"
export * from "./inviteFriendsGridItem.vue?vue&type=script&lang=js"
import style0 from "./inviteFriendsGridItem.vue?vue&type=style&index=0&id=058bc432&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "058bc432",
  null
  
)

export default component.exports